import moment from 'moment';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DateRange_Date,
  convertDateTypeDateRangePickerProps,
  getDateRangeWithFullDays,
} from '~/utils/helper';

export enum UserActivityLogTab {
  Changes = 'changes',
  Views = 'views',
}

export const useEmployeeActivityLog = (employeeId: number) => {
  const { t } = useTranslation();

  const defaultRequestParams = useMemo(
    () => ({
      startDate: moment().subtract(2, 'weeks').startOf('date').toDate(),
      endDate: moment().endOf('date').toDate(),
      employees: [employeeId],
    }),
    [employeeId],
  );

  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: defaultRequestParams.startDate,
    endDate: defaultRequestParams.endDate,
  });

  const onDateRangeChange = useCallback(
    (dateRange: DateRange_Date) => {
      const newDateRange = getDateRangeWithFullDays(dateRange);
      const [startDate, endDate] = newDateRange;

      if (!!startDate && !!endDate) {
        setSelectedDateRange({
          startDate: startDate,
          endDate: endDate,
        });
      }
    },
    [setSelectedDateRange],
  );

  const [activeTab, setActiveTab] = useState<UserActivityLogTab>(
    UserActivityLogTab.Changes,
  );

  const options = useMemo(() => {
    return [
      {
        value: UserActivityLogTab.Changes,
        label: t('changes'),
      },
      {
        value: UserActivityLogTab.Views,
        label: t('views'),
      },
    ];
  }, [t]);

  return {
    selectedDateRange,
    dateRangePickerProps: convertDateTypeDateRangePickerProps({
      value: [selectedDateRange.startDate, selectedDateRange.endDate],
      onChange: onDateRangeChange,
      maxDate: moment().toDate(),
    }),
    tabs: {
      value: activeTab,
      onChange: (_event: React.SyntheticEvent, value: UserActivityLogTab) => {
        setActiveTab(value);
      },
      options,
    },
  };
};
